'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { Banknote, TrendingUp, Receipt, Sprout, ArrowRight } from 'lucide-react';
import { HomeSectionLayout } from './HomeSectionLayout';

// --- Data ---

const needs = [{
  icon: TrendingUp,
  title: 'I need capital to grow',
  description: 'Fund production, hiring, marketing, or expansion into new channels.',
  color: 'bg-emerald-50 text-emerald-600'
}, {
  icon: Receipt,
  title: 'Cashflow is tight',
  description: 'Do things now to improve cashflow, free up working capital, and keep your business moving.',
  color: 'bg-blue-50 text-blue-600'
}, {
  icon: Banknote,
  title: 'I need to fund a large order',
  description: 'You have the order. Now you need the cash to produce and deliver it.',
  color: 'bg-amber-50 text-amber-600'
}, {
  icon: Sprout,
  title: 'What funding could I access?',
  description: 'Explore grants, tax incentives, R&D credits, and regional programmes.',
  color: 'bg-teal-50 text-teal-600'
}];

// --- Sub-components ---

function FundingNeeds() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">{needs.map(_temp)}</div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function _temp(need) {
  return <div key={need.title} className="relative rounded-xl border border-gray-200 bg-white p-6 hover:shadow-md transition-shadow"><h3 className="text-lg font-semibold text-gray-900 mb-1">{need.title}</h3><p className="text-sm text-gray-600 leading-relaxed">{need.description}</p></div>;
}
function FundingCTA() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="mt-10 text-center"><Link href="/money" className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-600 text-white font-semibold shadow-md hover:bg-primary-700 hover:shadow-lg transition-all duration-200 cursor-pointer">Unlock Money <ArrowRight className="w-5 h-5" /></Link></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}

// --- Main component ---

export function MoneySection() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <HomeSectionLayout title="Don't let money hold your business back" subtitle={<div><div>Practical help to improve cashflow, fund large orders, access free money, or raise capital for your next stage of growth.</div></div>}><FundingNeeds /><FundingCTA /></HomeSectionLayout>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}